<template>
    <!-- Global Travelers Community Section -->
    <div class="py-12 md:py-20 px-4 md:px-8">
        <div class="max-w-5xl mx-auto">
            <div class="text-center text-2xl md:text-4xl leading-tight">
                <p class="text-slate-800 dark:text-slate-100">
                    Join a community of people who want to
                </p>
                <h2 class="font-medium text-orange">
                    travel more and spend less.
                </h2>
                <p
                    class="text-slate-500 dark:text-slate-400 text-base mt-4 max-w-2xl mx-auto leading-relaxed"
                >
                    The 10xTravel+ private community is built around one
                    goal: helping you get more out of every trip. Get
                    real-time award alerts the moment high-value space
                    drops, join live Q&As and strategy sessions with the
                    10xTravel team, and connect with fellow members who
                    share tips, answer questions, and celebrate wins
                    together.
                </p>
            </div>

            <!-- Map Illustration -->

            <div class="relative">
                <div
                    class="lg:w-1/2 mx-auto flex items-center justify-center mb-6 -mt-2 lg:mt-2 overflow-hidden"
                >
                    <img
                        src="/images/community-preview.png"
                        alt="Growth Network community"
                        class="w-full object-cover rounded-lg"
                    />
                    <div class="hidden lg:block">
                        <img
                            src="../../../../images/plus-left-plane.svg"
                            alt=""
                            class="absolute left-32 top-9 w-[200px] pointer-events-none"
                        />
                        <img
                            src="../../../../images/plus-right-plane.svg"
                            alt=""
                            class="absolute right-24 top-16 w-[220px] pointer-events-none"
                        />
                    </div>
                </div>
                <!-- Community Features Grid -->
                <div
                    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
                >
                    <!-- award alerts -->
                    <div class="p-6 bg-white dark:bg-slate-800 rounded-lg shadow-sm">
                        <Icon
                            icon="bell"
                            :width="24"
                            :height="24"
                            class="text-orange mb-2"
                            containerClass="flex items-center justify-start"
                        />
                        <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                            Real-Time Award Alerts
                        </h3>
                        <p
                            class="text-sm text-slate-500 dark:text-slate-400 mt-2 leading-relaxed"
                        >
                            Get notified when high-value awards drop, and
                            book before they're gone.
                        </p>
                    </div>

                    <!-- family travel -->
                    <!-- <div class="p-6 bg-white dark:bg-slate-800 rounded-lg shadow-sm">
                    <Icon
                        icon="users"
                        :width="24"
                        :height="24"
                        class="text-orange mb-2"
                        containerClass="flex items-center justify-start"
                    />
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Family Travel
                    </h3>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">
                        Planning travel for a crew? Connect with other
                        family travelers who've cracked the code on using
                        points to take the trips that matter most.
                    </p>
                </div> -->
                    <!-- organized discussion spaces -->
                    <div class="p-6 bg-white dark:bg-slate-800 rounded-lg shadow-sm">
                        <Icon
                            icon="speech-bubble"
                            :width="24"
                            :height="24"
                            class="text-orange mb-2"
                            containerClass="flex items-center justify-start"
                        />
                        <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                            Dedicated Community Channels
                        </h3>
                        <p
                            class="text-sm text-slate-500 dark:text-slate-400 mt-2 leading-relaxed"
                        >
                            Chat with others who share your interests. Our
                            organized discussion spaces include Family
                            Travel, Points & Miles Strategy, Brags & Trip
                            Reports, and more!
                        </p>
                    </div>
                    <!-- live webinars -->
                    <div class="p-6 bg-white dark:bg-slate-800 rounded-lg shadow-sm">
                        <Icon
                            icon="webinar"
                            :width="24"
                            :height="24"
                            class="text-orange mb-2"
                            containerClass="flex items-center justify-start"
                        />
                        <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                            Live Webinars
                        </h3>
                        <p
                            class="text-sm text-slate-500 dark:text-slate-400 mt-2 leading-relaxed"
                        >
                            Join our experts for live demos, credit card
                            strategies, Q&As, and more. Every session is
                            recorded so you never miss one.
                        </p>
                    </div>

                    <!-- Announcements & Updates -->
                    <!-- <div class="p-6 bg-white dark:bg-slate-800 rounded-lg shadow-sm">
                    <Icon
                        icon="megaphone"
                        :width="24"
                        :height="24"
                        class="text-orange mb-2"
                        containerClass="flex items-center justify-start"
                    />
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Points & Miles Strategy
                    </h3>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">
                        Deep-dive discussions on maximizing your points,
                        finding the best redemptions, and staying ahead of
                        program changes. All in one dedicated space.
                    </p>
                </div> -->

                    <!-- Travel Talk & Recommendations -->
                    <!-- <div class="p-6 bg-white dark:bg-slate-800 rounded-lg shadow-sm">
                    <Icon
                        icon="microphone"
                        :width="24"
                        :height="24"
                        class="text-orange mb-2"
                        containerClass="flex items-center justify-start"
                    />
                    <h3 class="text-base font-medium text-slate-800 dark:text-slate-100">
                        Travel Talk & Recommendations
                    </h3>
                    <p class="text-sm text-slate-500 dark:text-slate-400 mt-2 leading-relaxed">
                        Looking for hotel recommendations in Sydney? Unsure
                        how to navigate public transportation in Rome? Ask
                        questions, share finds, and get personalized
                        guidance from the community.
                    </p>
                </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
</script>
